<template>
  <div>
    <vs-table
      search
      stripe
      border
      description
      :sst="true"
      :data="table.data"
      :max-items="table.length"
      :total="table.total"
      @search="handleSearch"
      @change-page="handleChangePage"
      @sort="handleSort"
    >
      <template slot="header">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ this.table.start }} - {{ this.table.end }} of
              {{ this.table.total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item
              v-for="item in table.limits"
              :key="item"
              @click="handleChangelength(item)"
            >
              <span>{{ item }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </template>
      <template slot="thead">
        <vs-th></vs-th>
        <vs-th sort-key="rp.code">Route Plan</vs-th>
        <vs-th sort-key="cvpl.date">Date</vs-th>
        <vs-th sort-key="p.name">Sales</vs-th>
        <vs-th sort-key="c.name">Customer</vs-th>
        <vs-th sort-key="rp.name">Address</vs-th>
        <vs-th sort-key="cv.status">Tasks</vs-th>
        <vs-th sort-key="cv.status">Customer Visit Status</vs-th>
        <vs-th sort-key="cv.visit_reason">Reason</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <div class="vx-input-group flex">
              <vs-button
                @click.stop="handleView(data[indextr].id)"
                size="small"
                color="rgb(41, 147, 138)"
                icon-pack="feather"
                icon="icon-eye"
                title="View Customer Log"
                style="margin-right: 5px"
              />
            </div>
          </vs-td>
          <vs-td :data="data[indextr].route_plan_code">
            {{ data[indextr].route_plan_code }}
            {{ data[indextr].schedule_type }} {{ data[indextr].day }}
            {{ data[indextr].odd_even }}
          </vs-td>
          <vs-td :data="data[indextr].date">
            {{ data[indextr].date }}
          </vs-td>
          <vs-td :data="data[indextr].work_id_number">
            {{
              data[indextr].work_id_number +
              " (" +
              data[indextr].code_external +
              ") " +
              data[indextr].personal_name
            }}
          </vs-td>
          <vs-td :data="data[indextr].customer_code">
            {{
              data[indextr].customer_code + " " + data[indextr].customer_name
            }}
          </vs-td>

          <vs-td :data="data[indextr].ca_code">
            <div v-html="addressData(data[indextr])"></div>
          </vs-td>
          <vs-td :data="data[indextr].ca_code">
            <div v-html="data[indextr].tasks"></div>
          </vs-td>
          <vs-td :data="data[indextr].status">
            {{ data[indextr].status }}
          </vs-td>
          <vs-td :data="data[indextr].visit_reason">
            {{ data[indextr].visit_reason }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <vs-pagination
      style="padding-top: 5px"
      :total="table.totalPage"
      v-model="setPage"
    />
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    baseUrl: {
      type: String,
    },
    status: {
      type: String,
    },
    customerVisitPlanLineID: {
      type: Number,
    },
    draw: {
      type: Number,
    },
  },
  data() {
    return {
      deleteId: null,
      table: this.tableDefaultState(),
    };
  },
  methods: {
    tableDefaultState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        // order: "id",
        order: "cvpl.updated_at",
        sort: "desc",
        total: 0,
        totalPage: 1,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
      };
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      this.getData();
    },
    handleChangePage(page) {
      this.table.page = page;
      this.getData();
    },
    handleSort(key, active) {
      this.table.order = key;
      this.table.sort = active;
      this.getData();
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.getData();
    },
    handleView(id) {
      this.$emit("viewLog", { id: id, status: this.status });
    },
    getData() {
      if (this.customerVisitPlanLineID) {
        this.$vs.loading();
        this.$http
          .get(this.baseUrl + "/customer/table", {
            params: {
              length: this.table.length,
              page: this.table.page,
              search: this.table.search,
              order: this.table.order,
              sort: this.table.sort,
              customer_visit_plan_line_id: this.customerVisitPlanLineID,
            },
          })
          .then((resp) => {
            if (resp.code == 200) {
              this.table.total = resp.data.total_record;
              this.table.totalPage = resp.data.total_page;
              this.table.totalSearch = resp.data.total_record_search;
              this.table.length = resp.data.total_record_per_page;
              this.table.data = resp.data.records;
              this.setStartEnd();
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
            }
          });
      }
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;

      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;

      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }

      if (
        this.table.totalSearch < this.table.total &&
        this.table.search != ""
      ) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
    addressData(data) {
      var html = "";

      if (data.ca_code) {
        html += data.ca_code + "<br>";
      }

      html += data.ca_contact_name + " " + data.ca_contact_mobile + "<br>";

      if (data.ca_address) {
        html += data.ca_address;
      }
      if (data.ca_sub_district) {
        html += ", " + data.ca_sub_district;
      }

      if (data.ca_district) {
        html += ", " + data.ca_district;
      }

      if (data.ca_city) {
        html += ", " + data.ca_city;
      }

      if (data.ca_province) {
        html += ", " + data.ca_province;
      }

      if (data.ca_country) {
        html += ", " + data.ca_country;
      }

      if (data.ca_postal_code) {
        html += " " + data.ca_postal_code;
      }

      if (data.ca_latitude || data.ca_longitude) {
        html += "<br> " + data.ca_latitude + ", " + data.ca_longitude;
      }

      return html;
    },
  },
  mounted() {},
  watch: {
    draw() {
      this.getData();
    },
    customerVisitPlanLineID() {
      this.getData();
    },
  },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
};
</script>
